import { motion } from "framer-motion";
import { CARE_POINTS } from "../../data/product";

// Animation config hoisted out of render (stable references).
const CARD_FADE_UP = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};
const cardTransition = (delay = 0) => ({ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] });

export const Reviews = () => (
  <section id="reviews" className="bg-[#EDE3D6]" data-testid="reviews-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-20 sm:py-28">
      <div className="mb-12">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-4">The Celusta Feel</p>
        <h2 className="font-serif-display font-medium text-4xl sm:text-5xl tracking-tight text-[#2B1F1B]">
          Care made <span className="italic text-[#3A2A25]">simple.</span>
        </h2>
        <p className="mt-4 text-base font-light text-[#756A64] max-w-xl">
          How the CELUSTA Leave-In Conditioner cares for your hair — softness, smoothness and
          effortless shine.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {CARE_POINTS.map((c, i) => (
          <motion.div
            key={c.title}
            {...CARD_FADE_UP}
            transition={cardTransition(i * 0.1)}
            className="bg-[#FFFDF9] rounded-xl p-8 border border-[rgba(58,42,37,0.08)] shadow-[0_4px_20px_rgba(58,42,37,0.05)]"
            data-testid={`care-card-${i}`}
          >
            <h3 className="font-serif-display text-2xl text-[#2B1F1B] mb-3">{c.title}</h3>
            <p className="text-sm font-light leading-relaxed text-[#756A64]">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
